<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <div class="row">
                    <b-form-input type="text" v-model="form.itemname"  ref="itemNameInput" @keypress.enter="submitForm()"/>
                    </div>
                </div>
              </div>

               <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.itemdescription"
                    rows="3"
                    max-rows="6"
                    @keypress.enter="submitForm()"
                  ></b-form-textarea>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category</label>
                  <div class="row">
                      <model-list-select
                        :list="categoryListFromApi"
                        v-model="form.itemcategory"
                        option-value="categoryid"
                        option-text="categoryname"
                        placeholder="Select category"
                      >
                      </model-list-select>
                    </div>
                    
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit</label>
                  <b-form-input type="text"  v-model="form.unit" @keypress.enter="submitForm()"/>
                </div>
              </div>
              

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>UnitPrice</label>
                  <b-form-input type="number"  v-model="form.unitprice" @keypress.enter="submitForm()"/>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Available</label>
                  <b-form-input type="number"  v-model="form.available" @keypress.enter="submitForm()"/>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Threshold</label>
                  <b-form-input type="number"  v-model="form.threshold" @keypress.enter="submitForm()"/>
                </div>
              </div>
              
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="productlist" class="btn btn-cancel">Cancel</router-link>
              </div>

            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
export default {
  data() {
    return {
      form: {
        itemname: '',
        itemdescription: '',
        itemcategory: '',
        categoryid:'',
        unit: '',
        unitprice:'0',
        available: '0',
        threshold: '0',
      },
      title: "Add Item",
      title1: "Create new item",
      categoryListFromApi: [],
    };
  },
  created(){
    this.fetchCategoryListFromApi();
  },
  mounted() {
    this.$refs.itemNameInput.focus();
  },
  methods: {
    async fetchCategoryListFromApi() {
    try {
      const response = await axios.get('/v1/category');
      this.categoryListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching category list:', error);
      }
    },

    postData() {
      if (!this.form.itemname) {
        Swal.fire("Please enter the item name");
        return;
      }

      if (!this.form.itemcategory) {
        Swal.fire("Please select a category");
        return;
      }
      
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .post('/v1/items', this.form)
          .then(response => {
            Swal.fire("Item created successfully");
            this.$router.push({ path: '/productlist' });
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
        }
      });
    },
    submitForm() {
      this.postData();
    }
  },
  components: {
    ModelListSelect
  },
  name: "addproduct",
};
</script>
